<ng-container
  *ngIf="(transactionTypeTexts$ | async) as transactionTypeTexts;"
>
  <div class="w-100 separator udex-mt-12 udex-mb-32"></div>
  <div class="quantity">
    <div class="col-12 col-sm-3 col-md-4 col-lg-3 d-flex flex-column udex-me-lg-12 udex-me-md-0 udex-me-sm-12">
      <h3
        class="udex-mb-20 udex-m-0 udex-mb-sm-12 udex-pb-sm-4 body--s d-flex flex-column justify-content-center text-nowrap"
        data-cy="license-count-label">
        {{ transactionTypeTexts?.quantity }}
      </h3>
    </div>
    <udex-step-input
      *ngIf="!isQuantityInputReadOnly; else showQuantityTextOnly"
      class="step-input udex-px-sm-0 udex-me-sm-16"
      [ngClass]="{'fit-content': (valueState$ | async) === 'Error'}"
      [value]="formControl.value"
      [min]="props.min"
      [step]="field.props?.step || 1"
      [max]="props.max"
      [valueState]="valueState$ | async"
      value-precision="0"
      [supportingText]="!!getTranslationValues() ? (errorMessage | cxTranslate: { value: getTranslationValues()}) : (errorMessage | cxTranslate)"
      (change)="onStepInputChange($event)"
      (value-state-change)="onValueStateChange($event)"
    ></udex-step-input>
    <div
      *ngIf="!isQuantityInputReadOnly"
      class="col-12 col-sm-6 col-md-5 col-lg-5 d-flex udex-my-xs-8"
      id="quantity-label"
    >
      <div class="metric-wrapper body--s min-input-height d-flex flex-row">
        <ng-container *ngIf="variantProduct$ | async as variantProduct">
          <dcp-metric-text [product]="variantProduct"></dcp-metric-text>
        </ng-container>
      </div>
    </div>
    <ng-template #showQuantityTextOnly>
      <div class="col-12 col-sm-4 col-lg-8 d-flex udex-my-xs-8" id="quantity-label-only">
        <div class="metric-wrapper body--s min-input-height d-flex flex-row">
          <ng-container *ngIf="variantProduct$ | async as variantProduct">
            <dcp-metric-text [product]="variantProduct" [quantity]="props.max"></dcp-metric-text>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
